import i18n from '@/language/i18n';

const SYS_CONFIG_MODULE_WINDOW_IDENTIFIER = Object.freeze({
  REGISTRY_MODULE: 'registryitems',
  CONFIGURATION_MODULE: 'configurations',
  NOTIFICATION_CONFIGURATION_MODULE: 'notificationConfigurationSchedulings',
  ATTRIBUTE_CATEGORY_MODULE_WINDOW_ID: 'attributecategories',
  DOCUMENT_MODULE: 'documents',
  ERROR_ANALYSIS_MODULE_WINDOW_ID: 'errorlogs',
  ADMIN_CONSOLE_MODULE_WINDOW_ID: 'adminConsole',
});

export { SYS_CONFIG_MODULE_WINDOW_IDENTIFIER };

export default {
  SYS_CONFIG_GROUP_WRAPPER: {
    type: 'group',
    id: 'systemConfiguration',
    label: i18n.t('ModuleRegistry.groups.systemConfiguration.name.label'),
    children: [],
    icon: '$wSettings',
    sidebarIcon: '$wNavSystemConfiguration'
  },
  CHILDREN: {
    REGISTRY_MODULE: {
      type: 'module',
      id: 'registry',
      windowIdentifierType: SYS_CONFIG_MODULE_WINDOW_IDENTIFIER.REGISTRY_MODULE,
      label: i18n.t(
        'ModuleRegistry.groups.systemConfiguration.labels.registry'
      ),
      navigationImg: require('@/assets/navigation/items/icon_registry.svg'),
      routerLink: '/registryitems',
      globalSearch: {
        index: 'registry',
      },
    },
    CONFIG_FIXTURES_MODULE: {
      type: 'module',
      id: 'fixtures',
      windowIdentifierType:
        SYS_CONFIG_MODULE_WINDOW_IDENTIFIER.CONFIGURATION_MODULE,
      label: i18n.t(
        'ModuleRegistry.groups.systemConfiguration.titles.fixtures'
      ),
      navigationImg: require('@/assets/navigation/items/icon_registry.svg'),
      routerLink: '/configurations',
      globalSearch: {
        index: 'fixtures',
      },
    },
    NOTIFICATION_CONFIGURATION_MODULE: {
      type: 'module',
      id: 'notificationConfiguration',
      windowIdentifierType:
        SYS_CONFIG_MODULE_WINDOW_IDENTIFIER.NOTIFICATION_CONFIGURATION_MODULE,
      hidden: true,
    },
    ATTRIBUTE_CATEGORIES_MODULE: {
      type: 'module',
      id: 'attributecategories',
      windowIdentifierType:
        SYS_CONFIG_MODULE_WINDOW_IDENTIFIER.ATTRIBUTE_CATEGORY_MODULE_WINDOW_ID,
      label: i18n.t(
        'ModuleRegistry.groups.systemConfiguration.titles.attributes'
      ),
      navigationImg: require('@/assets/navigation/items/icon_registry.svg'),
      routerLink: '/attributecategories',
      globalSearch: {
        overrideRouterLink: '/attributecategories',
        index: 'attributecategories',
        routerLink: '/attributecategories',
        presentation: i18n.t(
          'ModuleRegistry.groups.systemConfiguration.titles.attributes'
        ),
        component: 'AttributeItem',
      },
    },
    DOCUMENT_MODULE: {
      type: 'module',
      id: 'documents',
      windowIdentifierType: SYS_CONFIG_MODULE_WINDOW_IDENTIFIER.DOCUMENT_MODULE,
      label: i18n.t('Common.documents'),
      navigationImg: require('@/assets/navigation/items/icon_registry.svg'),
      routerLink: '/documents',
      globalSearch: {
        index: 'documents',
      },
    },
    ERROR_ANALYSIS_MODULE: {
      type: 'module',
      id: 'errorAnalysis',
      windowIdentifierType: SYS_CONFIG_MODULE_WINDOW_IDENTIFIER.ERROR_ANALYSIS_MODULE_WINDOW_ID,
      label: i18n.t('Common.errorAnalysis'),
      navigationImg: require('@/assets/navigation/items/icon_registry.svg'),
      routerLink: '/errorlogs',
    },
    ADMIN_CONSOLE_MODULE: {
      type: 'module',
      id: 'adminConsole',
      windowIdentifierType: SYS_CONFIG_MODULE_WINDOW_IDENTIFIER.ADMIN_CONSOLE_MODULE_WINDOW_ID,
      label: i18n.t('Common.adminConsole'),
      navigationImg: require('@/assets/navigation/items/icon_registry.svg'),
      routerLink: '/adminConsole',
    },
  },
};
